import rules from 'common/validation-rules';

export default {
  ProductCategory: function () {
    this.id = -1;
    this.deleted = false;
    this.nameJa = null;
    this.description = null;
    this.displayOrder = 0;

    /**
     * APIから取得したデータをセットする
     * @param {*} api APIから取得した商品情報
     */
    this.setApiData = function (api) {
      if (!api) return;

      if (api['id']) this.id = api['id'];
      if (api['deleted']) this.deleted = api['deleted'];
      if (api['name_ja']) this.nameJa = api['name_ja'];
      if (api['description']) this.description = api['description'];
      if (api['display_order']) this.displayOrder = api['display_order'];
    };
  },
};
